<div class="unlock-overlay" *ngIf="(!(profileState | async).boxExampleStatus[name()]) && (type() === 'profile' && !((profileState | async).audit !== null && (profileState | async).audit.status))">
  <div class="unlock-card">
    <div class="unlock-icon">
      <i class="bi bi-lock-fill"></i>
    </div>
    <h4 class="unlock-title">Premium Insight</h4>
    <p class="unlock-desc">Unlock detailed analytics and get the full picture of this profile's audience.</p>
    <a routerLink="/payment/add" class="unlock-btn">
      <i class="bi bi-lightning-charge-fill"></i>
      Unlock Full Report
    </a>
    <a class="unlock-preview" (click)="setExampleStatus(true)">
      <i class="bi bi-eye"></i> Preview with sample data
    </a>
  </div>
</div>
